import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface PublicUser {
  id: string;
  fullName: string | null;
  initials: string;
  userType: string;
}

export async function getPublicProfile(id: string): Promise<PublicUser> {
  const res = await apiClient.get<PublicUser>(ENDPOINTS.users.publicProfile(id));
  return res.data;
}
